import { ifSelectorExist, getElement, getElements } from "./utils";

export const AttorneyInfoTabs = () => {
  let tabsContent = getElements(".attorney_info--tabs-content"),
      tabsParent = getElement(".attorney_info--tabs-wrapper"),
      tabsItem = getElements(".attorney_info--tabs-item");

  if (ifSelectorExist(tabsItem) && ifSelectorExist(tabsContent) && ifSelectorExist(tabsParent)) {
    let hideTabContent = () => {
      tabsContent.forEach((element) => {
        element.classList.add("hidden");
        element.classList.remove("block");
      });

      tabsItem.forEach((element) => {
        element.classList.remove("active");
      });
    };

    let showTabContent = (i = 0) => {
      tabsContent[i].classList.add("block");
      tabsContent[i].classList.remove("hidden");
      tabsItem[i].classList.add("active");
    };

    tabsParent.addEventListener("click", (event) => {
      const target = event.target;

      if (target && target.classList.contains('attorney_info--tabs-item')) {
        tabsItem.forEach((element, i) => {
          if (target == element) {
            hideTabContent();
            showTabContent(i);
          }
        });
      }
    });

    hideTabContent();
    showTabContent();
  }
};
